<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">
        設備資料<template v-if="detail == true && add == true">建檔</template>
      </div>
      <div style="margin-top: 2rem">
        <div class="row">
          <template v-if="detail == false">
            <commonQueryInput
              :inputItems="multiInputItems"
              v-model:getValue="multiInputVal"
            ></commonQueryInput>
            <div class="text-end mt-3">
              <button
                type="button"
                class="btn p-0"
                style="
                  color: #fff;
                  background-color: #4b8c80;
                  width: 7rem;
                  height: 2rem;
                  font-size: 1.125rem;
                "
                @click="addDevice"
              >
                設備建檔
              </button>
            </div>
            <commonTable
              class="mt-3"
              :fields="currentDeviceTableFields"
              :items="currentDeviceTableItems"
              :rowClick="deviceRowClick"
              :theme="'green'"
              stickyHeader="230px"
            >
            </commonTable>
          </template>
          <template v-else-if="detail == true">
            <!-- <form> -->
            <div class="row g-3 m-0 text-start">
              <div class="col-md-6 mt-0">
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.factory.name }}:
                  </span>
                  <div class="col-sm-6">
                    <select
                      name="factory"
                      class="form-select"
                      :disabled="add != true && mod != true"
                      v-model="formListData.factory.value"
                    >
                      <option v-for="item in deviceSite" :value="item.value">
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.dep.name }}:
                  </span>
                  <div class="col-sm-6">
                    <select
                      name="dep"
                      class="form-select"
                      :disabled="add != true && mod != true"
                      v-model="formListData.dep.value"
                    >
                      <option
                        v-for="item in deviceDepartment"
                        :value="item.value"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.category.name }}:
                  </span>
                  <div class="col-sm-6">
                    <select
                      name="category"
                      class="form-select"
                      :disabled="add != true && mod != true"
                      v-model="formListData.category.value"
                    >
                      <option
                        v-for="item in deviceCategory"
                        :value="item.value"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.deviceID.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="deviceID"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.deviceID.value"
                    />
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.equipmentID.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="equipmentID"
                      type="text"
                      class="form-control"
                      :disabled="add != true"
                      v-model="formListData.equipmentID.value"
                      @blur="
                        changeValue(
                          'equipmentID',
                          formListData.equipmentID.value
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.deviceChineseName.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="deviceChineseName"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.deviceChineseName.value"
                    />
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.deviceName.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="deviceName"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.deviceName.value"
                    />
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.spec.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="spec"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.spec.value"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-0">
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.usageUnit.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="usageUnit"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.usageUnit.value"
                    />
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.principal.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="principal"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.principal.value"
                    />
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.manufacturer.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="manufacturer"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.manufacturer.value"
                    />
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.agent.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="agent"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.agent.value"
                    />
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.status.name }}:
                  </span>
                  <div class="col-sm-6">
                    <select
                      name="status"
                      class="form-select"
                      :disabled="add != true && mod != true"
                      v-model="formListData.status.value"
                    >
                      <option v-for="item in deviceState" :value="item.value">
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.commencementDate.name }}:
                  </span>
                  <div class="col-sm-6">
                    <template v-if="add != true && mod != true">
                      <input
                        name="commencementDate"
                        type="date"
                        class="form-control"
                        v-model="formListData.commencementDate.value"
                        disabled
                      />
                    </template>
                    <template v-else>
                      <commonDateInput
                        class="mes-maintain-input-date"
                        v-model:getValue="formListData.commencementDate.value"
                        type="date"
                      >
                      </commonDateInput>
                    </template>
                    <!-- <input
                      name="commencementDate"
                      type="text"
                      class="form-control"
                      :disabled="add != true && mod != true"
                      v-model="formListData.commencementDate.value"
                    /> -->
                  </div>
                </div>
                <template
                  v-if="
                    formListData.status.value == 2 ||
                    formListData.status.value == 3
                  "
                >
                  <div class="row mt-0 mb-3">
                    <span class="col-sm-4 col-form-label"
                      >{{ formListData.discontinuationDate.name }}:
                    </span>
                    <div class="col-sm-6">
                      <commonDateInput
                        class="mes-maintain-input-date"
                        v-model:getValue="
                          formListData.discontinuationDate.value
                        "
                        type="date"
                      >
                      </commonDateInput>
                    </div>
                  </div>
                </template>
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.drawings.name }}:
                  </span>
                  <div class="col-sm-6">
                    <div class="input-group">
                      <template v-if="add != true && mod != true">
                        <div
                          style="
                            cursor: pointer;
                            border: 1px solid rgba(118, 118, 118, 0.3);
                            background: #e9ecef;
                            padding: 6px;
                          "
                          :style="{
                            cursor: fileSrc !== '#' ? 'pointer' : 'unset',
                          }"
                          class="form-control file-input"
                          @click="previewInformation(fileSrc)"
                        >
                          {{ formListData.drawings.value }}
                        </div>
                        <a
                          class="btn remove-btn"
                          :href="fileSrc"
                          :download="formListData.drawings.value"
                          :class="{
                            disabled: formListData.drawings.value == '',
                          }"
                          >下載</a
                        >
                      </template>
                      <template v-else>
                        <input
                          name="drawings"
                          class="form-control file-input"
                          type="file"
                          :id="'formFile'"
                          :aria-describedby="'inputGroupRemove'"
                          :disabled="add != true && mod != true"
                          @change="onFileChange($event)"
                        />
                        <button
                          class="remove-btn"
                          @click="removeFile"
                          :id="'inputGroupRemove'"
                          :disabled="add != true && mod != true"
                        >
                          <font-awesome-icon
                            style="width: 25px"
                            :icon="['fas', 'trash-can']"
                          />
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-0">
                <div class="row mt-0 mb-3">
                  <span class="col-sm-2 col-form-label"
                    >{{ formListData.note.name }}:
                  </span>
                  <div class="col-sm-9">
                    <div class="form-floating">
                      <textarea
                        name="note"
                        class="form-control p-2"
                        placeholder="Leave a comment here"
                        id="floatingTextarea"
                        style="height: 100px; white-space: pre-line"
                        :disabled="add != true && mod != true"
                        v-model="formListData.note.value"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-0">
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.createDate.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="createDate"
                      type="text"
                      class="form-control"
                      disabled
                      v-model="formListData.createDate.value"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-0">
                <div class="row mt-0 mb-3">
                  <span class="col-sm-4 col-form-label"
                    >{{ formListData.creator.name }}:
                  </span>
                  <div class="col-sm-6">
                    <input
                      name="creator"
                      type="text"
                      class="form-control"
                      disabled
                      v-model="formListData.creator.value"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-0">
                <div class="row mt-0 mb-3">
                  <div class="col-sm-11 text-end">
                    <template v-if="add == true">
                      <button
                        type="button"
                        class="btn p-0 me-2"
                        style="
                          color: #fff;
                          background-color: #4b8c80;
                          width: 6rem;
                          height: 2rem;
                          font-size: 1.125rem;
                        "
                        @click="back"
                      >
                        取消
                      </button>
                      <button
                        type="button"
                        class="btn p-0"
                        style="
                          color: #fff;
                          background-color: #4b8c80;
                          width: 6rem;
                          height: 2rem;
                          font-size: 1.125rem;
                        "
                        @click="checkAdd"
                      >
                        確認
                      </button>
                    </template>
                    <template v-else-if="mod == true">
                      <button
                        type="button"
                        class="btn p-0 me-2"
                        style="
                          color: #fff;
                          background-color: #4b8c80;
                          width: 6rem;
                          height: 2rem;
                          font-size: 1.125rem;
                        "
                        @click="modDeviceCancel"
                      >
                        取消修改
                      </button>
                      <button
                        type="button"
                        class="btn p-0"
                        style="
                          color: #fff;
                          background-color: #4b8c80;
                          width: 6rem;
                          height: 2rem;
                          font-size: 1.125rem;
                        "
                        @click="modDeviceCheck"
                      >
                        確認修改
                      </button>
                    </template>
                    <template v-else>
                      <button
                        type="button"
                        class="btn p-0 me-2"
                        style="
                          color: #fff;
                          background-color: #4b8c80;
                          width: 6rem;
                          height: 2rem;
                          font-size: 1.125rem;
                        "
                        @click="back"
                      >
                        返回
                      </button>
                      <button
                        type="button"
                        class="btn p-0"
                        style="
                          color: #fff;
                          background-color: #4b8c80;
                          width: 6rem;
                          height: 2rem;
                          font-size: 1.125rem;
                        "
                        @click="modDevice"
                      >
                        進行修改
                      </button>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <!-- </form> -->
          </template>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import commonDateInput from "@/components/commonQueryInput/commonDateInput.vue";
import { computed, provide, ref, watch } from "vue";
import store from "@/store";
export default {
  components: {
    commonQueryInput,
    commonTable,
    commonDateInput,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const axiosDeviceFileResult = computed(
      () => store.getters["commonAxios/get_axiosDeviceFileResult"]
    );
    const deviceSite = computed(
      () => store.getters["selectOptions/get_deviceSite"]
    );
    const deviceDepartment = computed(
      () => store.getters["selectOptions/get_deviceDepartment"]
    );
    const deviceCategory = computed(
      () => store.getters["selectOptions/get_deviceCategory"]
    );
    const deviceState = computed(
      () => store.getters["selectOptions/get_deviceState"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      axiosActionDeviceFile: async (payload) => {
        await store.dispatch("commonAxios/axiosActionDeviceFile", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const fac = ref("");
    const dep = ref("");
    const category = ref("");
    const detail = ref(false);

    const formListData = ref({
      factory: { name: "廠區", value: "" },
      dep: { name: "部門", value: "" },
      category: { name: "設備類別", value: "" },
      deviceID: { name: "設備編號", value: "" },
      equipmentID: { name: "設備資產編號", value: "" },
      deviceChineseName: { name: "設備中文名稱", value: "" },
      deviceName: { name: "設備英文名稱", value: "" },
      spec: { name: "規格", value: "" },
      usageUnit: { name: "使用單位", value: "" },
      principal: { name: "使用單位負責人", value: "" },
      manufacturer: { name: "製造商", value: "" },
      agent: { name: "代理商", value: "" },
      status: { name: "設備狀態", value: "" },
      commencementDate: { name: "投用日期", value: "" },
      discontinuationDate: { name: "報廢或停用日期", value: "" },
      drawings: { name: "工程圖", value: "" },
      note: { name: "備註", value: "" },
      createDate: { name: "建檔日期", value: "" },
      creatorID: { name: "建檔人ID", value: "" },
      creator: { name: "建檔人", value: "" },
    });
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "fac",
        label: "廠區",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇廠區 --",
        options: deviceSite,
      },
      {
        key: "dep",
        label: "部門",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇部門 --",
        options: deviceDepartment,
      },
      {
        key: "category",
        label: "設備類別",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇設備 --",
        options: deviceCategory,
      },
    ]);
    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        mod.value = false;
        console.log(newValue);
        fac.value = newValue["fac"];
        dep.value = newValue["dep"];
        category.value = newValue["category"];

        queryDeviceInfo();
      },
      { deep: true }
    );

    const add = ref(false);
    const mod = ref(false);
    const fileSrc = ref("#");

    const currentDeviceTableFields = ref([
      {
        key: "category",
        label: "設備類別",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "device",
        label: "設備編號",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "equipmentID",
        label: "設備資產編號",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "chineseName",
        label: "設備中文名稱",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "status",
        label: "設備狀態",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "unitOfUse",
        label: "使用單位",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const currentDeviceTableItems = ref([]);

    //查詢設備資料
    const queryDeviceInfo = () => {
      currentDeviceTableItems.value = [];
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "QueryDeviceInfo";
      params["fac"] = fac.value;
      params["dep"] = dep.value;
      params["category"] = category.value;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          currentDeviceTableItems.value = QueryTableData;
        } else {
          currentDeviceTableItems.value = [];
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    };
    const deviceRowClick = (itemData) => {
      querySelectDeviceInfo(itemData.equipmentID);
      //   maintainData.value = getMaintainData(itemData);
    };

    //查詢該列設備資料
    const querySelectDeviceInfo = (equipmentID) => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "QuerySelectDeviceInfo";
      params["equipmentID"] = equipmentID;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          for (const key in QueryTableData) {
            if (Object.prototype.hasOwnProperty.call(QueryTableData, key)) {
              if (key === "src") {
                fileSrc.value = QueryTableData[key];
                continue;
              }
              formListData.value[key].value = QueryTableData[key];
            }
          }

          detail.value = true;
          add.value = false;
          mod.value = false;
        } else {
          methods.setTimeoutAlert(response);
          back();
        }
        methods.triggerLoadingBar();
      });
    };

    //按下設備建檔
    const addDevice = () => {
      // Replace these values with the appropriate field names
      const { creator, creatorID, createDate, ...rest } = formListData.value;

      // Update creator and createDate fields
      formListData.value = {
        ...rest, // Keep the name properties intact
        creator: { name: "建檔人", value: loginData.value.username }, // Update creator with a new value
        creatorID: { name: "建檔人", value: loginData.value.account }, // Update creator with a new value
        createDate: {
          name: "建檔日期",
          value: new Date().toISOString().slice(0, 10),
        }, // Set createDate to today's date
      };
      Object.keys(rest).forEach((key) => {
        formListData.value[key].value = ""; // Set the value property to an empty string
      });

      detail.value = true;
      add.value = true;
      mod.value = false;
    };

    const orgFormListData = ref({});
    //進入修改畫面
    const modDevice = () => {
      orgFormListData.value = JSON.parse(JSON.stringify(formListData.value));

      detail.value = true;
      add.value = false;
      mod.value = true;
    };

    //取消修改
    const modDeviceCancel = () => {
      formListData.value = JSON.parse(JSON.stringify(orgFormListData.value));

      detail.value = true;
      add.value = false;
      mod.value = false;
    };
    //確認修改
    const modDeviceCheck = () => {
      methods.triggerLoadingBar();
      const updateData = {};
      for (const key in formListData.value) {
        if (orgFormListData.value.hasOwnProperty(key)) {
          const orgValue = orgFormListData.value[key].value;
          let currentValue = formListData.value[key].value;
          if (key === "commencementDate" || key === "discontinuationDate") {
            const isObjectWithValue =
              typeof formListData.value[key].value === "object" &&
              formListData.value[key].value !== null;
            if (isObjectWithValue) {
              currentValue = formListData.value[key].value.startDate;
            }
          }
          if (orgValue !== currentValue) {
            if (key == "drawings" && currentValue == null) {
              continue;
            }
            updateData[key] = currentValue;
          }
        }
      }

      console.log(updateData);
      if (Object.keys(updateData).length === 0) {
        methods.setTimeoutAlert("無修改項目");
        methods.triggerLoadingBar();
        return;
      }

      const formData = new FormData();
      let attachments = [];
      // 將選取的檔案加入 FormData 中
      if (files.value != null) {
        formData.append("files[]", files.value);
        attachments.push(files.value.name);
        formData.append("dir", formListData.value.deviceID.value);
        methods.axiosActionDeviceFile(formData).then(() => {
          let result = axiosDeviceFileResult.value;
          console.log(result);
          let response = result.Response;
          if (response != "ok") {
            methods.triggerLoadingBar();
            methods.setTimeoutAlert("請重新上傳檔案");
            return;
          }
          modDeviceInfo(updateData);
        });
      } else {
        modDeviceInfo(updateData);
      }
    };

    const modDeviceInfo = (updateData) => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateDeviceInfo";
      params["equipmentID"] = formListData.value.equipmentID.value;
      params["updateData"] = updateData;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] != "ok") {
          methods.setTimeoutAlert(result["Response"]);
        } else {
          querySelectDeviceInfo(formListData.value.equipmentID.value);
        }
        methods.triggerLoadingBar();
      });
    };

    //返回
    const back = () => {
      queryDeviceInfo();
      detail.value = false;
      add.value = false;
      mod.value = false;
    };
    const files = ref(null);
    const onFileChange = (event) => {
      const fileList = event.target.files;
      if (fileList.length > 0) {
        const newFile = fileList[0];
        files.value = newFile;
        formListData.value.drawings.value = newFile.name;
      } else {
        files.value = null;
        formListData.value.drawings.value = null;
      }
    };

    //按下確認新增設備按鈕
    const checkAdd = () => {
      for (const key in formListData.value) {
        if (
          key === "drawings" ||
          key === "discontinuationDate" ||
          key === "note"
        ) {
          continue;
        }

        if (formListData.value[key].value === "") {
          methods.setTimeoutAlert(
            `請將 "${formListData.value[key].name}" 資料填寫完畢`
          );
          return;
        }
      }

      methods.triggerLoadingBar();
      const formData = new FormData();
      let attachments = [];
      // 將選取的檔案加入 FormData 中
      if (files.value != null) {
        formData.append("files[]", files.value);
        attachments.push(files.value.name);
        formData.append("dir", formListData.value.equipmentID.value);
        methods.axiosActionDeviceFile(formData).then(() => {
          let result = axiosDeviceFileResult.value;
          console.log(result);
          let response = result.Response;
          if (response != "ok") {
            methods.triggerLoadingBar();
            methods.setTimeoutAlert("請重新上傳檔案");
            return;
          }
          addDeviceInfo();
        });
      } else {
        addDeviceInfo();
      }
      return;
    };

    //確認新增設備資料
    const addDeviceInfo = () => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "AddDevice";
      params["formListData"] = formListData.value;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] != "ok") {
          add.value = true;
          methods.setTimeoutAlert(result["Response"]);
        } else {
          // 查詢資料
          fac.value = formListData.value.factory.value;
          dep.value = formListData.value.dep.value;
          category.value = formListData.value.category.value;
          back();
        }
        methods.triggerLoadingBar();
      });
    };

    //移除檔案
    const removeFile = () => {
      const fileInput = document.getElementById("formFile");
      if (fileInput) {
        fileInput.value = null; // Clear the file input value
      }
      files.value = null;
      formListData.value.drawings.value = null;
    };

    const changeValue = (type, value) => {
      console.log(type, value);
      switch (type) {
        case "equipmentID":
          const equipmentID = formListData.value.equipmentID.value;

          let contactParams = {};
          contactParams["webPage"] =
            sideNavPath.value.length != 0
              ? sideNavPath.value[sideNavPath.value.length - 1]
              : null;
          contactParams["user"] = loginData.value.account;
          contactParams["vuePage"] = "devicemanagement";
          contactParams["methods"] = "POST";
          contactParams["whichFunction"] = "CheckDeviceChangeValue";
          contactParams["equipmentID"] = equipmentID;
          methods.axiosAction(contactParams).then(() => {
            let result = axiosResult.value;
            if (result["Response"] != "ok") {
              methods.setTimeoutAlert("此編號已新增，請重新輸入");
              formListData.value.equipmentID.value = "";
            }
          });
          break;

        default:
          break;
      }
    };

    const previewInformation = (src) => {
      if (src !== "#") {
        window.open(src, "_blank");
      }
    };

    const commonMethods = {};

    provide("add", add);
    // provide("commonMethods", commonMethods);
    return {
      deviceSite,
      deviceDepartment,
      deviceCategory,
      deviceState,
      multiInputVal,
      multiInputItems,
      detail,
      formListData,
      add,
      mod,
      fileSrc,
      back,
      checkAdd,
      currentDeviceTableFields,
      currentDeviceTableItems,
      deviceRowClick,
      addDevice,
      modDevice,
      modDeviceCancel,
      modDeviceCheck,
      onFileChange,
      removeFile,
      changeValue,
      previewInformation,
    };
  },
};
</script>

<style scoped>
.form-select {
  background: #fff
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
    no-repeat right 0.75rem center/8px 10px;
}
.form-select:disabled {
  background-color: #e9ecef;
}
</style>
